import { call, takeLatest, put } from 'redux-saga/effects';
import AUTH_TYPES from './types';
import authActions from './actions';
import AuthService from 'src/service/authService';
import { cookies, sagaWrapper } from 'src/helpers';
import { type ILoginResponse } from 'src/models';
import { history } from 'src/store';

import notificationActions from '../Notifications/actions';
import userActions from '../Users/actions';
import institutionActions from '../Institutions/actions';
import courseActions from '../Courses/actions';
import sectionActions from '../Sections/actions';
import moment from 'moment';

const authService = new AuthService();

function* login({ payload }: any) {
	try {
		const response: ILoginResponse = yield call(authService.login, {
			username: payload.username,
			password: payload.password,
		});

		cookies.set('auth', response.token, {
			path: '/',
			secure: true,
			expires: moment(response.expiresIn).toDate(),
		});

		yield put(authActions.successLogin(response));

		if (response?.type === 'User') yield history.push('/app/courses');
		else yield history.push('/app/home');

	} catch {
		yield put(authActions.loginFailed());
		yield put(notificationActions.add('error', 'Error de autenticación'));
	}
}

function* logout() {
	yield put(userActions.initialState());
	yield put(institutionActions.initialState());
	yield put(sectionActions.initialState());
	yield put(courseActions.initiaState());

	// yield localStorage.clear();
	yield history.push('/login');
	yield cookies.remove('auth', {
		path: '/',
		secure: true,
	});
}

function* me() {
	try {
		const response: ILoginResponse = yield call(authService.me);
		yield put(authActions.successLogin(response));
	} catch (error) {
		yield put(notificationActions.add('error', 'Error al obtener los datos del usuario'));
	}
}

export default function* index() {
	yield takeLatest(AUTH_TYPES.LOGIN, sagaWrapper(login));
	yield takeLatest(AUTH_TYPES.LOGOUT, sagaWrapper(logout));
	yield takeLatest(AUTH_TYPES.ME, sagaWrapper(me, authActions.logout()));
}
